<div class="pill-switch-options-container" role="radiogroup">
  @for (option of options; track option) {
    <button
      class="pill-switch-option"
      [class.selected]="selected === option.value"
      [class.disabled]="disabled"
      type="button"
      [disabled]="disabled"
      [attr.aria-checked]="selected === option.value"
      (click)="disabled ? null : pillClicked(option)"
      (keydown.enter)="pillClicked(option)"
      (keydown.space)="pillClicked(option)">
      <span class="pill-switch-option-label">
        {{ option.label | translate }}
      </span>
    </button>
  }
</div>
